<template>
  <v-layout>
    <v-card contextual-style="dark">
      <span slot="header">
        My Account
      </span>
      <div slot="body">
      </div>
    </v-card>
  </v-layout>
</template>

<script>
/* ============
 * Account Index Page
 * ============
 *
 * Page where the user can view the account information.
 */
import store from '@/store';

import VLayout from '@/layouts/Default.vue';
import VCard from '@/components/Card.vue';

export default {
  /**
   * The name of the page.
   */
  name: 'OrderUnits',

  /**
   * The components that the page can use.
   */
  components: {
    VLayout,
    VCard,
  },

  beforeRouteEnter(to, from, next) {
    !store.state.unitTypes.unitTypes.length && store.dispatch('unitTypes/load', { order: to.params.order });
    !store.state.filters.filters.length && store.dispatch('filters/load', { order: to.params.order });

    !store.state.units.units.length && store.dispatch('units/load', { order: to.params.order })
      .then(res => next())
      .catch(() => {
        // commit('setApiError', err)
      });

    // next();
  },
};
</script>
